/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_List_Filter_Active_SanctionInputs */



/**
* | output |
* | --- |
* | "Active sanction" |
*
* @param {User_List_Filter_Active_SanctionInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const user_list_filter_active_sanction = /** @type {((inputs?: User_List_Filter_Active_SanctionInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_List_Filter_Active_SanctionInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sanction active")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sanción activa")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Sanção ativa")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sanzione attiva")
	return /** @type {LocalizedString} */ ("Active sanction")
});